import { getSessionValue } from '@/fo/api/magento';
import { apiMindbox, MINDBOX_OPERATIONS } from '@/fo/api/mindbox';

const clearAll = async () => {
  const customerMindboxId = await getSessionValue('CUSTOMER_MINDBOX_ID');

  return await apiMindbox(MINDBOX_OPERATIONS.CART_CLEAR, {
    customer: customerMindboxId
      ? { ids: { bitrixClientId: customerMindboxId } }
      : undefined
  });
};

const update = async (
  items: { id: string; count: number; price: number }[]
) => {
  return await apiMindbox(MINDBOX_OPERATIONS.CART_CREATE, {
    productList: items.map(({ id, count, price }) => ({
      product: {
        ids: {
          bitrixProducts: id
        }
      },
      count,
      pricePerItem: price
    }))
  });
};

export const cartMindboxService = {
  clearAll,
  update
};
